import { AGE_VALUES, GENDER_OPTIONS } from '@/features/audiences/model';

const VALID_GENDER_VALUES = GENDER_OPTIONS.map((option) => option.value);

/**
 * Lowercase to match GENDER_OPTIONS values, which use lowercase.
 */
export function normalizeGender(gender: string): string {
  const normalized = gender.toLowerCase();
  return VALID_GENDER_VALUES.includes(normalized) ? normalized : '';
}

/**
 * API stores specific ages ("38") but the form uses range options ("35-44").
 */
export function mapAgeToRange(age: string): string {
  if ((AGE_VALUES as readonly string[]).includes(age)) return age;

  const numericAge = parseInt(age, 10);
  if (isNaN(numericAge)) return '';

  // eslint-disable-next-line i18next/no-literal-string -- returns an AGE_VALUES entry, the value the form persists
  if (numericAge < 18) return 'Under 18';
  if (numericAge <= 24) return '18-24';
  if (numericAge <= 34) return '25-34';
  if (numericAge <= 44) return '35-44';
  if (numericAge <= 54) return '45-54';
  if (numericAge <= 64) return '55-64';
  return '65+';
}
